import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { PartyQuery } from './PartyQuery';
import { PersonQuery } from './PersonQuery';

@supertypeClass({ toClient: true, toServer: true })
export class ApplicantQuery extends Everything {
  @property()
  party: PartyQuery;

  constructor() {
    super();
  }

  static new() {
    return new ApplicantQuery().init();
  }

  init() {
    return this;
  }

  get person(): PersonQuery {
    return <PersonQuery>this.party;
  }

  get address() {
    return this.person.residentialAddress;
  }

  get phone() {
    return this.party.phone;
  }
}
